import { PartCategory } from "src/api/generated/erp/db/types/tables/partCategory";
import { PartCategoryApi } from "src/api/generated/erp/parts/categories/partCategoryApi";
import { mergeSx } from "src/utils/styles";
import { columnFlex, flex1, overflowAuto, dFlex } from "src/styles/sx";
import { PartCategoriesActions } from "src/components/views/erp/parts/partCategories/PartCategoriesActions";
import { AsyncRender } from "src/components/common/async/AsyncRender";
import { PartCategoriesTreeView } from "src/components/views/erp/parts/partCategories/PartCategoriesTreeView";
import { Box } from "@mui/material";
import { useAsyncFetch } from "src/utils/async/asyncFetch.ts";
import { GenericDialogContext } from "src/components/common/dialogs/GenericDialogProvider.tsx";
import i18n from "i18next";
import {
	PartCategoryForm,
	PartCategoryFormProps
} from "src/components/views/erp/parts/partCategories/PartCategoryForm.tsx";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export interface PartCategoriesViewProps {
	selectedPartCategory: PartCategory | null;
	setSelectedPartCategory: React.Dispatch<React.SetStateAction<PartCategory | null>>;
}

export const PartCategoriesView = ({
									   selectedPartCategory,
									   setSelectedPartCategory
								   }: PartCategoriesViewProps) => {
	const [partCategoriesAsync, refreshPartCategories] = useAsyncFetch(PartCategoryApi.getAll);

	const { openDialog } = useContextOrThrow(GenericDialogContext);

	const openPartCategoryFormDialog = (params: Partial<PartCategoryFormProps>) =>
		openDialog(({ closeDialog, onContentEdited }) => ({
			size: "sm",
			title: i18n.t("part_category"),
			children: <PartCategoryForm
				{...params}
				onCompleted={async (result) => {
					await closeDialog();
					await refreshPartCategories();
					params.onCompleted?.(result);
				}}
				onFormEdited={onContentEdited}
			/>
		}));

	return (
		<Box sx={mergeSx(columnFlex, flex1)}>
			<PartCategoriesActions
				selectedPartCategory={selectedPartCategory}
				setSelectedPartCategory={setSelectedPartCategory}
				refreshPartCategories={refreshPartCategories}
				openPartCategoryFormDialog={openPartCategoryFormDialog}
			/>
			<Box sx={mergeSx(flex1, overflowAuto, dFlex)}>
				<AsyncRender
					asyncData={partCategoriesAsync}
					content={(partCategories) => {
						return (
							<PartCategoriesTreeView
								partCategories={partCategories}
								refreshData={refreshPartCategories}
								selectedPartCategory={selectedPartCategory}
								setSelectedPartCategory={setSelectedPartCategory}
								openPartCategoryFormDialog={openPartCategoryFormDialog}
							/>
						);
					}}
				/>
			</Box>
		</Box>
	);
};
